import { VALID } from 'common/const';

const FIELD = {
  address1: {
    label: 'Address 1',
    placeholder: 'Street Name, Building Number, etc',
    validation: VALID.ADDRESS.required('Address is required'),
  },
  address2: {
    label: 'Address 2',
    placeholder: 'Neighbourhood',
    validation: VALID.ADDRESS_2.required('Neighbourhood is required'),
  },
  city: {
    label: 'District',
    validation: VALID.CITY.required('District is required'),
  },
  state: {
    label: 'Province',
    validation: VALID.PROVINCE.required('Province is required'),
  },
  zip: {
    label: 'Postal Code',
    validation: VALID.POSTAL_CODE.required('Postal code is required'),
  },
};

export default FIELD;
